module.exports = __webpack_public_path__ + "static/media/vibinoLogo.7d6438dd.svg";